/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { Select, Typography } from '@neo4j-ndl/react';
import { useState } from 'react';

const EXAMPLE_OPTIONS = [
  { label: 'Neo4j', value: 'neo4j' },
  { label: 'Needle 🪡', value: 'needle' },
  { label: 'Graph Databases', value: 'graph-database' },
  { isDisabled: true, label: 'Disabled database option', value: 'disabled' },
];

const Component = (props: React.ComponentProps<typeof Select>) => {
  const [value, setValue] = useState<(typeof EXAMPLE_OPTIONS)[number]>(
    EXAMPLE_OPTIONS[0],
  );

  return (
    <div className="n-flex n-flex-col n-gap-token-8">
      <Select
        label="Label"
        type="select"
        selectProps={{
          isMulti: false,
          menuIsOpen: props.selectProps?.menuIsOpen,
          menuPortalTarget: document.querySelector('body'),
          onChange: (newValue) => newValue && setValue(newValue),
          options: EXAMPLE_OPTIONS,
          value: value,
        }}
      />
      <Typography variant="body-small">
        Value Selected: {JSON.stringify(value)}
      </Typography>
    </div>
  );
};

export default Component;
